import { BgColorPalette } from '@/constants/colors';
import styled from 'styled-components';

export const StyledBillingSwitcher = styled.div`
  display: inline-flex;
  background: #e8f0fe;
  border: 1.5px solid #b8d0f8;
  border-radius: 100px;
  padding: 3px;
  gap: 0;
  max-width: 100%;
  overflow-x: auto;
  scrollbar-width: none;
  scroll-snap-type: x mandatory;

  &::-webkit-scrollbar {
    display: none;
  }

  /* BfS 4.1.2 mobile-friendly: wrap pill xuống hàng riêng thay vì clip ở mép viewport */
  @media (max-width: 490px) {
    display: flex;
    flex-wrap: wrap;
    border-radius: 16px;
    gap: 4px;
  }
`;

export const StyledBillingOption = styled.button<{ $active?: boolean }>`
  padding: 8px 20px;
  border-radius: 100px;
  border: none;
  background: ${({ $active }) => ($active ? '#fff' : 'none')};
  box-shadow: ${({ $active }) => ($active ? '0 1px 3px rgba(0,0,0,0.12)' : 'none')};
  color: #1a1a2e;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s;
  flex-shrink: 0;
  scroll-snap-align: center;
  &:hover {
    background: ${({ $active }) => ($active ? '#fff' : 'rgba(255,255,255,0.5)')};
  }

  /* mobile: hai option chia đều hàng 1 cho cân */
  @media (max-width: 490px) {
    flex: 1;
    text-align: center;
  }
`;

export const StyledBundlePill = styled.button`
  padding: 8px 20px;
  border-radius: 100px;
  border: none;
  background: #0057d9;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  scroll-snap-align: center;
  &:hover {
    background: #0046b3;
  }

  /* mobile: pill xuống full-width hàng 2 — không tràn/clip viewport */
  @media (max-width: 490px) {
    width: 100%;
    flex-basis: 100%;
  }
`;

export const StyledSubscriptionPlans = styled.div<{ $isUpgradePlan: boolean }>`
  .subscription-button,
  .plan-compare-link {
    display: flex;
    align-items: center;
    justify-content: center;

    &-skeleton {
      width: 13.375rem;
    }
  }

  .subscription-button {
    > * {
      max-width: 100%;
    }

    @media (max-width: 480px) {
      width: 100%;

      .Polaris-Card button {
        width: 100%;
        justify-content: center;
      }
    }
  }

  .plans-comparison {
    .comparison-skeleton {
      margin-top: 0.5rem;
      width: 100%;
      background-color: #fff;
      border: 0.0625rem solid ${BgColorPalette.SECONDARY_ACTIVE};
      padding: 0.65rem 0;
      .Polaris-SkeletonBodyText__SkeletonBodyTextContainer {
        margin: 0 auto;
        & > div {
          width: 20%;
          height: 1.5rem;
          margin: 0 auto;
        }
      }
    }
  }
`;
